import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { selectPlanData } from 'src/app/core/store/plan/plan.selectors';
import { SubscriptionPlan } from 'src/app/core/models/stripe.models';

@Component({
    selector: 'app-history-usage',
    templateUrl: './history-usage.component.html',
    styleUrls: ['./history-usage.component.scss'],
    standalone: false
})
export class HistoryUsageComponent implements OnInit, OnDestroy {

  @Input() isFreemium: () => boolean;
  @Input() isStarter: () => boolean;
  @Input() isGrowth: () => boolean;

  size: number = 185;
  // Applied by vng-gauge via [style.stroke] (a real style binding), so a CSS
  // custom property resolves here. --vng-color-accent replaces the retired
  // #F15A2A literal.
  foregroundColor: string = 'var(--vng-color-accent)';
  type: string ="full";
  thickness:number = 15;
  characters: number = 0;
  spell_check_language: string = 'English';
  designatedTotal: number = 100;

  config: any = {
    value: 0,
    size: this.size,
    designatedTotal: 0,
    thickness: this.thickness,
    foregroundColor: this.foregroundColor
  }

  flycut: any = {
    name: "FlyCuts",
    ...this.config
  } ;

  flyplate: any = {
    name: "FlyPlates",
    ...this.config
  };

  category: any = {
    name: "Categories",
    ...this.config
   };

  subcategory: any = {
    name: "Subcategories",
    ...this.config
  };

  currentPlan$: Observable<SubscriptionPlan | null> = this.store.select(selectPlanData);
  private subscription: Subscription;

  constructor(
    private store: Store,
  ) {

  }

  ngOnInit(): void {
    this.subscription = this.currentPlan$
      .subscribe((currentPlan: SubscriptionPlan | null) => {
        if (currentPlan?.statistics) {
          const statistics = currentPlan.statistics;

          this.flycut.value = statistics.shortcuts;
          this.flycut.designatedTotal = this.isGrowth() ? this.designatedTotal : statistics.shortcuts_available;

          this.flyplate.value = statistics.templates;
          this.flyplate.designatedTotal = this.isGrowth() ? this.designatedTotal : statistics.templates_available;

          this.category.value = statistics.categories;
          this.category.designatedTotal = this.isGrowth() ? this.designatedTotal : statistics.categories_available;

          this.subcategory.value = statistics.sub_categories;
          this.subcategory.designatedTotal = this.isGrowth() ? this.designatedTotal : statistics.sub_categories_available;

          this.characters = statistics.characters;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
